<template>
  <BasicModal
    :title="'面接予定日: ' + seeker.name"
    :isShowModal="isShowModal"
    width="960px"
    :canCansel="false"
    @cancel="cancel"
  >
    <div class="small-card-body" v-if="step===0">
      <SettingInterviewDate
        :getInterviewDate="getInterviewDate"
        :seeker="seeker"
        :date="date"
        :startHour="startHour"
        :startMinute="startMinute"
        :endHour="endHour"
        :endMinute="endMinute"
        :setDate="setDate"
        :users="users"
        :user="user"
        :calendarSettings="[]"
        :changeShowEvent="createUuidArr"
        :changeShowEventSelf="createUuidArr"
        :createCalendarSettings="createUuidArr"
        :isEditableCalendarSettings="isEditableCalendarSettings"
        :calendarUserExists="calendarUserExists"
        :usersStatusAPI="usersStatusAPI"
        :getUsersStatus="getUsersStatus"
        @emitDate="changeDate"
        @emitStartHour="changeStartHour"
        @emitStartMinute="changeStartMinute"
        @emitEndHour="changeEndHour"
        @emitEndMinute="changeEndMinute"
        @openCalendar="openCalendar"
      />
    </div>
    <div class="card-body" v-if="step===1">
      <div style="width: 80%; margin: auto">
        <MailActionContent
          :chatbots="chatbots"
          :recordingInterviews="recordingInterviews"
          :users="users"
          :bulk="false"
          :options="options"
          :emailTemplates="emailTemplates"
          :copyLink="copyLink"
          :sendEmailToSeeker="sendEmailToSeeker"
          :sendLoadding="sendLoadding"
          :sendEmailTemplate="sendEmailTemplate"
          :changeEmailTemplate="changeEmailTemplate"
          :tempSaveEmail="tempSaveEmail"
          :helpMessage="helpMessage"
          :openEmailMenu="openEmailMenu"
          :isSaveButton="true"
          :isLinkMenu="true"
          :isReplaceExplanation="true"
          :date="{'start_date_and_time': startDateAndTime, 'end_date_and_time': endDateAndTime}"
        />
      </div>
    </div>
    <div v-if="step===-1">
      <div style="display: flex; height: 70vh;">
        <div style="margin: 16px; overflow-y: scroll;">
          <div style="position: relative">
            <FullCalendar
              class="calendar-view"
              ref="fullCalendar"
              :locale="locale"
              :defaultView="defaultView"
              :duration="duration"
              :plugins="calendarPlugins"
              :slotDuration="'00:15:00'"
              :slotLabelInterval="'01:00'"
              :defaultDate="selectedDate"
              :selectable="true"
              :initialView="initialView"
              :events="schedulesFilter"
              :validRange="validRange"
              @eventPositioned="eventPositioned"
              @select="select"
              @eventClick="eventClick"
            />
            <div v-if="isScheduleLoading" class="calendar-loading-mask">
              <div class="mdi mdi-loading mdi-spin" style="font-size: 40px;"></div>
            </div>
          </div>
        </div>
        <div style="max-width: 240px; width:100%; margin: 16px 16px 16px 0; display: flex; flex-direction: column;">
          <p style="text-align: left; font-weight: bold">表示したい予定の人物を選択してください。</p>
          <div class="calendar-users-wrapper">
            <CalendarAPIStatusUsers
              :users="users"
              :user="user"
              :calendarSettings="calendarSettings"
              :changeShowEvent="createUuidArr"
              :changeShowEventSelf="changeShowEventSelf"
              :createCalendarSettings="createCalendarSettings"
              :isEditableCalendarSettings="isEditableCalendarSettings"
              :usersStatusAPI="usersStatusAPI"
              :getUsersStatus="getUsersStatus"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="card-body" v-if="step===2">
      確認画面
    </div>
    <!-- フッターアクション -->
    <div class="footer-box" v-if="step===0">
      <button class="button" @click="cancel">キャンセル</button>
      <b-button v-if="calendarUserExists" class="button is-primary" @click="createSchedule()" :disabled="isNextButtonDisables || isLoadingForSchedule" :loading="isLoadingForSchedule">
        カレンダーに登録する
      </b-button>
      <b-button v-else class="button is-primary" @click="confirmSchedule" :disabled="isNextButtonDisables || isLoadingForSchedule" :loading="isLoadingForSchedule">
        確定する
      </b-button>
    </div>
    <div class="footer-box" v-if="step===1">
      <button class="button" @click="cancel()">送付せず終了する</button>
      <div style="width: 47%;"></div>
    </div>
    <div class="footer-box" v-if="step===-1">
      <button class="button" @click="changeStep(1); clearDisplay();">戻る</button>
    </div>
    <slot></slot>
  </BasicModal>
</template>

<script>
import moment from 'moment'
import FullCalendar from "@fullcalendar/vue"
import dayGridPlugin from "@fullcalendar/daygrid"
import timeGridPlugin from "@fullcalendar/timegrid"
import interactionPlugin from "@fullcalendar/interaction"
import jaLocale from "@fullcalendar/core/locales/ja"
import BasicModal   from '@/components/Modals/BasicModal'
import SettingInterviewDate from "@/components/organisms/emails/SettingInterviewDate";
import MailActionContent from "@/components/organisms/emails/MailActionContent";
import CalendarAPIStatusUsers from '@/components/Calendar/organisms/CalendarAPIStatusUsers'
import color from '@/assets/json/master/color.json'
import hex2rgb from '@/functions/hex2rgb'
import createUUID from '@/functions/createUUID'
import { autoColor } from '@/functions/balloonFunc'
import { mapState } from 'vuex'
import controlLogMixin from '@/mixins/controlLogMixin'

export default {
  components: {
    BasicModal,
    FullCalendar,
    MailActionContent,
    SettingInterviewDate,
    CalendarAPIStatusUsers
  },
  mixins: [
    controlLogMixin
  ],
  props: {
    isShowModal: {
      type: Boolean,
      required: true
    },
    seeker: {
      type: Object,
      required: false
    },
    users: {
      type: Array,
      required: false
    },
    user: {
      type: Object,
      required: false
    },
    chatbots: {
      type: Array,
      required: true
    },
    recordingInterviews: {
      type: Array,
      required: true
    },
    options: {
      type: Object,
      required: true
    },
    emailTemplates: {
      type: Array,
      required: true
    },
    sendEmailToSeeker: {
      type: Function,
      required: true
    },
    sendLoadding: {
      type: Boolean,
      required: true
    },
    sendEmailTemplate: {
      type: Object,
      required: false
    },
    changeEmailTemplate: {
      type: Function,
      required: true
    },
    tempSaveEmail: {
      type: Function,
      required: true
    },
    helpMessage: {
      type: Function,
      required: true
    },
    copyLink: {
      type: Function,
      required: true
    },
    openEmailMenu: {
      type: Function,
      required: true
    },
    calendarSettings: {
      type: Array,
      required: true,
    },
    archiveSwitch: {
      type: Boolean,
      required: true,
    },
    blacklistSwitch: {
      type: Boolean,
      required: true,
    },
    orSwitch: {
      type: Boolean,
      required: true,
    },
    filtered: {
      type: Array,
      required: true,
    },
    seekersPages: {
      type: Number,
      required: true,
    },
    perPage: {
      type: Number,
      required: true,
    },
    currentManage: {
      type: Number
    },
    usersStatusAPI: {
      type: Array,
      required: true,
    },
    isDuplicateSeekerFlag: {
      type: Boolean,
      required: false,
      default: false,
    },
    isGetRoboTalk: {
      type: Boolean,
      required: false,
      default: false,
    }
  },
  data () {
    return {
      step: 0,
      selectDate: 'today',
      selected: {},
      calendar: null,
      viewType: '週',
      nowTime: null,
      clientid: null,
      subdomain: null,
      locale: jaLocale,
      header: {
        left: 'prev,next today',
        center: 'title',
        right: 'dayGridMonth,timeGridWeek,timeGridDay'
      },
      defaultView: 'timeGrid',
      duration: { days: 3 },
      selectedDate: "",
      calendarWeekends: true,
      calendarPlugins: [
        dayGridPlugin,
        timeGridPlugin,
        interactionPlugin,
      ],
      fileSelected: null,
      isOpenFileList: false,
      initialView: 'timeGrid',
      date: null,
      startHour: '0',
      startMinute: '0',
      endHour: '0',
      endMinute: '0',
      startDateAndTime: null,
      endDateAndTime: null,
      colorList: color,
      isSelfCheck: true,
      isFilterLoading: false,
      isLoadingForSchedule: false,
      uuidArr: [],
      calendarUserExists: false
    }
  },
  computed: {
    ...mapState('calendar', ['schedules', 'isScheduleLoading']),
    ...mapState('auth', ['user', 'users']),
    isNextButtonDisables() {
      if
        (
          !this.date ||
          Number(this.endHour) < Number(this.startHour) ||
          (Number(this.endHour) === Number(this.startHour) && Number(this.endMinute) <= Number(this.startMinute))
        ) {
          return true
        } else {
          return false
        }
    },
    schedulesFilter () {
      const schedulesFilter = []
      this.isFilterLoading = true
      for (const s of this.schedules) {
        for (const c of this.calendarSettings) {
          if (s.className === 'class-' + c.calendar_user) {
            schedulesFilter.push(s)
            break
          }
        }
      }
      this.isFilterLoading = false
      return schedulesFilter
    },
    startDate () {
      const date = new Date
      // 月末にsetMonthで月を変更すると、日付を基準に計算されてしまう
      // なので月ごとに異なる月末日を1日にしてからsetMonthを行う
      // その後にsetDateで日を設定する
      date.setDate(1)
      date.setYear(this.date.getFullYear())
      date.setMonth(this.date.getMonth())
      date.setDate(this.date.getDate())
      date.setHours(this.startHour)
      date.setMinutes(this.startMinute)
      date.setSeconds(0)
      date.setMilliseconds(0)
      return date
    },
    endDate () {
      const date = new Date
      // 月末にsetMonthで月を変更すると、日付を基準に計算されてしまう
      // なので月ごとに異なる月末日を1日にしてからsetMonthを行う
      // その後にsetDateで日を設定する
      date.setDate(1)
      date.setYear(this.date.getFullYear())
      date.setMonth(this.date.getMonth())
      date.setDate(this.date.getDate())
      date.setHours(this.endHour)
      date.setMinutes(this.endMinute)
      date.setSeconds(0)
      date.setMilliseconds(0)
      return date
    },
    validRange() {
      // 前後1ヶ月まで。
      const tempStartDate = new Date(this.selectedDate)
      tempStartDate.setMonth(tempStartDate.getMonth() - 1)
      tempStartDate.setDate(tempStartDate.getDate() - 1)
      const startDate = moment(tempStartDate).format("YYYY-MM-DD")

      const tempEndDate = new Date(this.selectedDate)
      tempEndDate.setMonth(tempEndDate.getMonth() + 1)
      tempEndDate.setDate(tempEndDate.getDate() + 1)
      const endDate = moment(tempEndDate).format("YYYY-MM-DD")
      return {
        start: startDate,
        end: endDate
      }
    },
  },
  async created() {
    this.openEmailMenu()
    if (this.schedules.length === 0) {
      await this.getSchedules()
    }
  },
  mounted() {
    this.calendarUserExistsCheck()
  },
  watch: {
    step () {
      if (this.step === 1) {
        this.setMeetingNewDate()
      }
    }
  },
  methods: {
    calendarUserExistsCheck() {
      for (let us of this.usersStatusAPI) {
        if (us.status === 'ok') {
          this.calendarUserExists = true
        }
      }
    },
    async getSchedules() {
      const date = new Date(this.selectedDate)
      await this.$store.dispatch('calendar/getSchedules', {
        year     : date.getFullYear(),
        month    : date.getMonth() + 1,
        day      : date.getDate(),
        category : '2month'
      })
    },
    createSchedule() {
      this.setMeetingNewDate()
      this.executeCreateSchedule()
    },
    async executeCreateSchedule () {
      if (this.startDate > this.endDate){
        alert("開始時刻は終了時刻より前に設定してください。")
        return
      }
      if (this.uuidArr.length === 0) {
        alert("登録先のカレンダーを選択してください。")
        return
      }
      this.sendControlLog('面接予定日登録', '面接予定日モーダルにて、「カレンダーに登録する」ボタンをクリックした。')
      const id = createUUID()
      const createdSchedule = {
        id: id,
        scheduleId: id,
        user_hash: this.uuidArr,
        user_hash_list: this.uuidArr,
        company_hash: this.user.companyID,
        title: this.seeker.name + '様面接',
        location: '',
        start: this.startDate,
        end: this.endDate,
        memo: '',
        isAllDay: false,
        category: 'time',
        state: '',
        isVisible: true,
        isPrivate: 'public',
        isReadOnly: false,
        color: '#000',
        bgColor: '#59C8C9',
        borderColor: '#59C8C9',
        dragBgColor: '#59C8C9',
        is_AND: true,
        re_message: '',
        is_private: 'public',
        sessionid: this.seeker.sessionid,
        seekerid: this.seeker.id
      }
      const interviewHistory = {
        seeker: this.seeker.id,
        interview_start: this.startDate,
        interview_end: this.endDate,
        interview_comment: '',
      }
      try {
        this.isLoadingForSchedule = true
        await this.$store.dispatch('calendar/autoCreateSchedule', createdSchedule)
        await this.$store.dispatch('directtalk/createInterviewHistory', interviewHistory)
        this.isLoadingForSchedule = false
        this.getSubscribedSeekers()
        const confirm = window.confirm('予定をカレンダーに登録しました。\n続けて応募者にメールを送付できます。\nメール編集画面へ遷移しますか？')
        if (confirm) {
          this.changeStep(1)
        } else {
          this.cancel()
        }
      } catch (e) {
        isLoadingForSchedule = false
        alert('エラーが発生いたしました。')
        return
      }
    },
    async confirmSchedule () {
      if (this.startDate > this.endDate){
        alert("開始時刻は終了時刻より前に設定してください。")
        return
      }
      this.sendControlLog('面接予定日確定', '面接予定日モーダルにて、「確定する」ボタンをクリックした。')
      this.isLoadingForSchedule = true

      let prom_fs = this.$store.dispatch('calendar/addEventFromScenarioAny', {
        sessionid: this.seeker.sessionid,
        start: this.startDate,
        end: this.endDate,
      })
      let prom_ih = this.$store.dispatch('directtalk/createInterviewHistory', {
        seeker: this.seeker.id,
        interview_start: this.startDate,
        interview_end: this.endDate,
        interview_comment: '',
      })
      let prom_aa = this.$store.dispatch('directtalk/setAutoAction', {
        timing: 1,
        session_id: this.seeker.sessionid,
        end: this.endDate,
      })
      await Promise.all([prom_fs, prom_ih, prom_aa])
      this.getSubscribedSeekers()
      this.isLoadingForSchedule = false
      this.changeStep(1)
    },
    getSubscribedSeekers() {
      const getSeekerConditions = {
        is_archive: this.archiveSwitch,
        is_blacklist: this.blacklistSwitch,
        filter_type: this.orSwitch,
        filter: this.filtered,
        page: this.seekersPages,
        perPage: this.perPage,
        manageid: this.currentManage,
        is_duplicate_seeker_flag: this.isDuplicateSeekerFlag,
        is_get_robo_talk: this.isGetRoboTalk
      }
      const authUser = this.users.filter(i=>i.email === this.user.email)
      this.$store.dispatch('directtalk/getSubscribedSeekers', {conditions: getSeekerConditions, authUser: authUser, isAgent: this.user.isAgent})
    },
    // 自分の予定は保存しない, ON/OFF切り替えのみ
    changeShowEventSelf() {
      this.isSelfCheck = !this.isSelfCheck
      this.$emit('changeShowEventSelf', this.isSelfCheck)
    },
    isEditableCalendarSettings(u) {
      for (const cs of this.calendarSettings) {
        if (u.user_hash === cs.calendar_user) {
          return true
        }
      }
      return false
    },
    autoColor (c) {
      const color = hex2rgb(c)
      return autoColor(color)
    },
    async createCalendarSettings (data) {
      const color = this.colorList[Math.floor( Math.random() * (13 + 1 - 0) ) + 0].code
      try {
        if (data.other) {
          await this.$store.dispatch('auth/createUserCalendarSettingDisplay', {
            user: this.user.userHash,
            calendar_user: data.user.user_hash,
            background_color: color,
            color: this.autoColor(color)
          })
        } else {
          this.$store.dispatch('auth/deleteUserCalendarSettingDisplay', {
            user: this.user.userHash,
            calendar_user: data.user.user_hash,
          })
        }
      } catch(e) {
        console.error(e)
        alert('エラーが発生いたしました。')
      }
    },
    clearDisplay() {
      this.$store.dispatch('auth/clearUserCalendarSettingDisplay')
    },
    createUuidArr(data) {
      if (this.uuidArr.includes(data.user.user_hash)) {
        this.uuidArr = this.uuidArr.filter((uuid) => {
          return uuid !== data.user.user_hash
        });
      } else {
        this.uuidArr.push(data.user.user_hash)
      }
    },
    setMeetingNewDate() {
      const yearAndDate = moment(this.date).format("YYYY/MM/DD(ddd)")
      const startHour = this.addFirstLetterZero(this.startHour)
      const startMinute = this.addFirstLetterZero(this.startMinute)
      const endHour = this.addFirstLetterZero(this.endHour)
      const endMinute = this.addFirstLetterZero(this.endMinute)
      this.startDateAndTime = this.createDateAndTime(yearAndDate, startHour, startMinute)
      this.endDateAndTime = this.createDateAndTime(yearAndDate, endHour, endMinute)
    },
    addFirstLetterZero (str) {
      if (str.length === 1) {
        return '0' + str
      } else {
        return str
      } 
    },
    createDateAndTime (yearAndDate, hour, minute) {
      return `${yearAndDate}${hour}:${minute}`
    },
    changeDate (value) {
      this.date = value
    },
    changeStartHour (value) {
      this.startHour = value
    },
    changeStartMinute (value) {
      this.startMinute = value
    },
    changeEndHour (value) {
      this.endHour = value
    },
    changeEndMinute (value) {
      this.endMinute = value
    },
    cancel () {
      this.$emit('cancel', false, null)
    },
    changeStep (v) {
      this.$set(this, 'step', this.step += v)
      this.$forceUpdate()
    },
    getInterviewDate (seeker) {
      let dList = []
      if (seeker.interview_history[0].interview_provisional) {
        dList = seeker.interview_history[0].interview_provisional.split('\n')
      }
      return dList.map((obj) => {
        return moment(obj.split('~')[0]).format('L(dd)LT～') + moment(obj.split('~')[1]).format('LT')
      })
    },
    eventPositioned (info) {
      if (info.view.viewSpec.type === 'listWeek') {
        let els = document.querySelectorAll('td.fc-widget-header')
        for (let e of els) {
          e.colSpan = '4'
        }
      }
    },
    select (info) {
      this.$refs.create.info = {
        title: null,
        start: info.start,
        end: info.end,
        calendarType: this.authType,
        description: null,
        attendees: [],
        attendees_departments: [],
        attendees_positions: []
      }
      this.$refs.create.step = 0
      this.$refs.create.isCreateFromDate = true
      this.$refs.create.isCardModalActive = true
    },
    eventClick (info) {
      this.$refs.edit.info = {
        id: info.event.id,
        title: info.event.title,
        start: info.event.start,
        end: info.event.end,
        borderColor: info.event.borderColor,
        backgroundColor: info.event.backgroundColor,
        textColor: info.event.textColor,
        eventFileRef: info.event.eventFileRef,
        description: info.event.extendedProps.description,
        calendarType: info.event.extendedProps.calendarType,
        attendees: info.event.extendedProps.attendees,
        eventJson: info.event.extendedProps.eventJson,
        startEditable: info.event.startEditable,
        invitation: info.event.extendedProps.invitation !== undefined ? info.event.extendedProps.invitation : ''
      }
      this.$refs.edit.isCardModalActive = true
    },
    createEvent (task) {
      let now = new Date(
        new Date().getFullYear(),
        new Date().getMonth(),
        new Date().getDate(),
        new Date().getHours()
      )
      let start = new Date(
        new Date().getFullYear(),
        new Date().getMonth(),
        new Date().getDate(),
        new Date().getHours()
      )
      start.setMinutes(60)
      let end = new Date(
        new Date().getFullYear(),
        new Date().getMonth(),
        new Date().getDate(),
        new Date().getHours()
      )
      end.setMinutes(60)
      end.setMinutes(task.time_min)
      this.$refs.create.info = {
        title: task.title,
        start: start,
        end: end,
        calendarType: this.authType,
        description: task.description,
        attendees: [],
        attendees_departments: [],
        attendees_positions: []
      }
      this.$refs.create.taskFiles = task.user_task_file
      this.$refs.create.isFileAttach = true
      this.$refs.create.step = 0
      this.$refs.create.isCreateFromDate = true
      this.$refs.create.isCardModalActive = true
    },
    setDate(candidateDateAndTime) {
      const candidateDateAndTimeArr = candidateDateAndTime.split('/')
      const day = candidateDateAndTimeArr[2].split('(')[0]
      const time = candidateDateAndTimeArr[2].split(')')[1]
      const timeArr = this.generateTimeArr(time)
      const startTimeArr = this.generateStartTimeArr(timeArr)
      const endTimeArr = this.generateEndTimeArr(timeArr)
      this.date = this.createDate(day, candidateDateAndTimeArr)
      this.startHour = this.generateStartHour(startTimeArr)
      this.startMinute = this.generateStartMin(startTimeArr)
      this.endHour = this.generateEndHour(endTimeArr)
      this.endMinute = this.generateEndMin(endTimeArr)
    },
    generateTimeArr(time) {
      return time.split('～')
    },
    generateStartTimeArr(timeArr) {
      const startTime = timeArr[0]
      const startTimeArr = startTime.split(':')
      return startTimeArr
    },
    generateEndTimeArr(timeArr) {
      const endTime = timeArr[1]
      const endTimeArr = endTime.split(':')
      return endTimeArr
    },
    createDate(day, candidateDateAndTimeArr) {
      const date = new Date()
      date.setUTCFullYear(Number(candidateDateAndTimeArr[0]))
      date.setUTCMonth(Number(candidateDateAndTimeArr[1]) - 1)
      date.setDate(Number(day))
      date.setHours(0)
      date.setMinutes(0)
      date.setSeconds(0)
      date.setMilliseconds(0)
      return date
    },
    generateStartHour(startTimeArr) {
      return String(Number(startTimeArr[0]))
    },
    generateStartMin(startTimeArr) {
      return String(Number(startTimeArr[1]))
    },
    generateEndHour(endTimeArr) {
      return String(Number(endTimeArr[0]))
    },
    generateEndMin(endTimeArr) {
      return String(Number(endTimeArr[1]))
    },
    setSelectedDate(d) {
      const tmpArr = d.split('(')[0].split('/')
      const year = Number(tmpArr[0])
      const month = Number(tmpArr[1])
      const date = Number(tmpArr[2])
      const newDate = new Date()
      // 月末にsetMonthで月を変更すると、日付を基準に計算されてしまう
      // なので月ごとに異なる月末日を1日にしてからsetMonthを行う
      // その後にsetDateで日を設定する
      newDate.setDate(1)
      newDate.setYear(year)
      newDate.setMonth(month - 1)
      newDate.setDate(date - 1)
      this.selectedDate = moment(newDate).format("YYYY-MM-DD")
      this.getSchedules()
    },
    openCalendar(d) {
      this.setSelectedDate(d)
      this.step = -1
    },
    getUsersStatus(u) {
      for (let us of this.usersStatusAPI) {
        if (u.user_hash === us.user_hash) {
          return us
        }
      }
    },

  }
}
</script>

<style lang="scss" scoped>
.card-body {
  padding: 24px;
  overflow: auto;
}
.desc {
  font-size: smaller;
  color: #666;
  text-align: left;
}
.input-field {
  padding: 8px;
  p {
    font-weight: 600;
    margin-bottom: 4px;
  }
}
.table-box {
  display: block;
  height: 100%;
  width: 100%;
  overflow: auto;
  tr {
    display: table;
    width: 100%;
    td {
      padding: 8px;
      height: auto;
      min-height: 36px;
    }
  }
}
.table-box::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}
.table-td {
  vertical-align: middle;
  border: solid thin #ccc;
  padding: 2px;
  textarea {
    border: dotted thin #ccc;
    min-height: 36px;
    resize: none;
    background: transparent; border-radius: 0; height: 100%; width: 100%;
  }
}
.table-th {
  padding: 2px 8px;
  text-align: center;
  vertical-align: middle;
  border: solid thin #ccc;
  font-size: 14px;
}
.file-box {
  font-size: smaller;
  overflow: hidden;
  width: 100%;
  height: 24px;
  display: inline-flex;
  margin-bottom: 4px;
  img {
    width: 16px; height: 16px; margin-right: 4px;
  }
  span {
    cursor: pointer; color: red; margin-right: 8px;
  }
  a {
    display: block;
    width: 150px;
    text-align: left;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }
}
.footer-box {
  width: 100%;
  height: 64px;
  border-top: solid thin #ccc;
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-wrap: wrap;
  overflow: auto;
  button {
    width: 47%;
  }
}
.calendar-loading-mask {
  position: absolute;
  background: white;
  width: 100%;
  height: 100%;
  top: 0;
  z-index: 10;
  display: flex;
  justify-content: center;
  align-items: center;
}
.calendar-users-wrapper {
  overflow-x: hidden;
  overflow-y: auto;
  height: 100%;
  margin-top: 8px;
}
.calendar-users-wrapper::-webkit-scrollbar {
  width: 8px;
}
</style>


// WEBPACK FOOTER //
// src/components/Manage/ModalSetDate.vue